import { getResource } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty, isNil } from 'lodash';
import { Company } from '@dispatch/shared/types';

export const useGetResource = ({
  id,
  company,
  enabled,
}: {
  id: string;
  company: Company;
  enabled?: boolean;
}) => {
  const {
    data: resource,
    status: resourceStatus,
    refetch: refetchResource,
  } = useQuery(['resource', id], () => getResource(id), {
    enabled: enabled && !isNil(id) && !isEmpty(id),
    staleTime: 60000,
  });

  if (resource && company) {
    resource.company = company;
  }

  return {
    data: resource,
    status: resourceStatus,
    refetch: refetchResource,
  };
};
